/**
 * This function replaces tags in a string with their respective arguments.
 *
 * It takes a string and either an object with key-value pairs or an array of strings.
 *
 * If an object is provided, it replaces each variable denoted as '{key}' in the input string
 * with the corresponding value from the object.
 *
 * If an array is provided, it replaces each variable denoted as '{index}' in the input string
 * with the corresponding value from the array.
 *
 * @export
 * @param {string} input - The input string containing tags to be replaced.
 * @param {{ [key: string]: string } | string[]} args - An object or array containing values
 * that will replace the tags in the input string.
 * @returns {string} An new string where all tags are replaced with their respective arguments.
 */

export function formatString(input: string, args: { [key: string]: string } | string[]): string {
    let result = input;

    if (Array.isArray(args)) {
        args.forEach((arg, index) => {
            const regExp = new RegExp(`\\{${index}\\}`, 'g');
            result = result.replace(regExp, arg);
        });
    } else {
        for (const key in args) {
            const regExp = new RegExp(`\\{${key}\\}`, 'g');
            result = result.replace(regExp, args[key]);
        }
    }

    return result;
}
